import { render, staticRenderFns } from "./InfoChart.vue?vue&type=template&id=410b8422&scoped=true"
import script from "./InfoChart.vue?vue&type=script&lang=js"
export * from "./InfoChart.vue?vue&type=script&lang=js"
import style0 from "./InfoChart.vue?vue&type=style&index=0&id=410b8422&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410b8422",
  null
  
)

export default component.exports